export const FETCH_SIGNUP_REQUEST = 'FETCH_SIGNUP_REQUEST'
export const FETCH_SIGNUP_SUCCESS = 'FETCH_SIGNUP_SUCCESS'
export const FETCH_SIGNUP_FALUIRE = 'FETCH_SIGNUP_FALUIRE'
